import * as React from "react";
function SvgTime(props, svgRef) {
  return <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><g style={{
      fill: "none",
      stroke: "var(--svg-color, var(--default-svg-color, #000))"
    }}><path d="M12 3C7.03125 3 3 7.03125 3 12C3 16.9688 7.03125 21 12 21C16.9688 21 21 16.9688 21 12C21 7.03125 16.9688 3 12 3Z" strokeWidth={1.5} strokeMiterlimit={10} /><path d="M12 6V12.75H16.5" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g></svg>;
}
const ForwardRef = React.forwardRef(SvgTime);
export default __webpack_public_path__ + "src/assets/icons/time.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/assets/icons/time_0.5x.svg",
  "1x": __webpack_public_path__ + "src/assets/icons/time_1x.svg",
  "2x": __webpack_public_path__ + "src/assets/icons/time_2x.svg",
  "3x": __webpack_public_path__ + "src/assets/icons/time_3x.svg",
  "4x": __webpack_public_path__ + "src/assets/icons/time_4x.svg"
};
export { ForwardRef as ReactComponent };